module.exports = __webpack_public_path__ + "img/GERA_2020_FRA_Karte.png";